@if (true) {
<div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog-FactSheet">
        <div class="modal-content">
            <div class="modal-header BlueHeader">
                <h4 class="Heading"> {{ModelFor}}</h4><br>
                <button type="button" class="close" (click)="getMaster(id,'')" data-dismiss="modal">&times;</button>
                <!-- <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()" data-dismiss="modal">&times;</button> -->
            </div>
            <div class="modal-body  col-sm-12 form-group">
                <iframe width="100%" Height="400 px" [src]="modalURL|safe"></iframe>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="table-header-container">
        <div class="table-heading">
            Manage General Masters
        </div>
    </div>

    <div class="row">
        <div class="col-md-3">
            <div class="category-card">
                <!-- Card Header -->
                <div class="card-header">
                    <span class="title">Categories</span>
                    <span class="total">{{ masters?.length }} Total</span>
                </div>

                <!-- Card List -->
                <div class="card-body" style="height : 80vh; overflow-y: scroll;" >

                    @for (master of masters; track $index) {
                    <div class="category-item" [class.selected]="id == master.GenID"
                        (click)="getMaster(master.GenID,master.GenDescr)">
                        <span class="name">{{ master.GenDescr }}</span>
                        <!-- <span class="count"> 25 </span> -->
                    </div>
                    }

                </div>
            </div>
        </div>

        <div class="col-md-9">
            <div class="table-header-container">
                <div class="table-heading">
                    Manage {{ManageMasterName}} Master
                </div>
                <form [formGroup]="FormSearchGenMaster" (ngSubmit)="onSearchGenMaster(FormSearchGenMaster.value)">
                    <div class="d-flex">
                        <div class="input-group">
                            <input type="text" placeholder="Search here..." class="table-search-input form-control"
                                formControlName="txtSearch">
                            <span class="input-group-btn">
                                <button class="btn btn-primary" title="Search">
                                    <i class="fas fa-magnifying-glass"></i>
                                </button>
                            </span>
                        </div>
                        @if (RightsID.includes('202042001') || RightsID.includes('202042021') ) {
                        <button type="button" title="Create {{ManageMasterName}} Master"  class="btn btn-outline-primary mx-2 " data-toggle="modal"
                         (click)="OpenModal('/add-masters',ManageMasterName,'0');" data-target="#ModalPopUP" >
                            <i class="fas fa-plus"></i>
                        </button>
                        }
                    </div>
                </form>
            </div>
            <div class="card table-container">
                <table class="custom-table">
                    <thead>
                        <tr>
                            <th>SR. NO.</th>
                            <th>NAME</th>
                            <th>SHORT NAME</th>
                            <th class="action-column" >ACTION</th>
                        </tr>
                    </thead>
    
                    <tbody>
                        <app-table-state
                        [loading]="isLoading"
                        [empty]="filteredData?.length == 0"
                        [rows]="10"
                        [columns]="4">
                        </app-table-state>
                        @if (!isLoading && filteredData?.length>0) {
                        @for (mDtl of filteredData | paginate : { itemsPerPage: pageSize, currentPage: pageNumber }; track $index; let i = $index) {
                        <tr>
                            <td>{{ (pageNumber - 1) * pageSize + i + 1 }}</td>
    
                            <!-- Master Name -->
                            <td>
                                @if (RightsID.includes('202042001') || RightsID.includes('202042021')) {
                                <a class="cursor-pointer" data-toggle="modal" data-target="#ModalPopUP"
                                    (click)="OpenModal1('/add-masters', mDtl.GenDescr, mDtl.ID)">
                                    {{ mDtl.MainDescr }}
                                </a>
                                } @else {
                                <span>{{ mDtl.MainDescr }}</span>
                                }
                            </td>
    
                            <!-- Abbreviation -->
                            <td>{{ mDtl.Abbrv }}</td>
    
                            <!-- Actions -->
                            <td class="d-flex gap-2 align-items-center action-column">
                                 <button class="status-btn" [class.enable]="mDtl.Status === 'Enable'"
                                    [class.disable]="mDtl.Status === 'Disable'" (click)="disablefunction(mDtl);">
                                    {{ mDtl.Status }}
                                </button>

                                <!-- Edit -->
                                @if (RightsID.includes('202042001') || RightsID.includes('202042021')) {
                                <button class="icon-btn icon-btn-primary" data-toggle="modal" data-target="#ModalPopUP"
                                    (click)="OpenModal1('/add-masters', mDtl.GenDescr, mDtl.ID)">
                                    <i class="fa fa-pencil"></i>
                                </button>
                                }
    
                                <!-- Delete -->
                                @if (RightsID.includes('202042021')) {
                                <button class="icon-btn icon-btn-danger" (click)="deleteGenMaster(mDtl.ID)" title="Delete">
                                    <i class="fa fa-trash"></i>
                                </button>
                                } @else {
                                <button class="icon-btn icon-btn-danger" (click)="onDelete()" title="Delete">
                                    <i class="fa fa-trash"></i>
                                </button>
                                }
    
                            </td>
                        </tr>
                        }
                        }
                    </tbody>
                </table>
            </div>
            <!-- @if (filteredData?.length > 0) {
                <div class="d-flex justify-content-end my-3">
                    <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
                </div>
            } -->
        @if (filteredData?.length > 0) {
            <div class="d-flex justify-content-between my-3 w-100">
                <div class="w-50">
                    <app-rows-per-page
                    [pageSize]="pageSize"
                    [total]="totalRecords"
                    [pageIndex]="pageNumber"
                    (pageSizeChange)="onPageSizeChange($event)">
                </app-rows-per-page>
                </div>
                <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
            </div>
        }
        </div>

    </div>
</div>
} @else {
<!-- <my-content placeholder="navigation">


    <div class="col-sm-12 divbordergry "></div>
    <div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
        <div class="modal-dialog-FactSheet">
            <div class="modal-content">
                <div class="modal-header BlueHeader">
                    <h4 class="Heading"> {{ModelFor}}</h4><br>
                    <button type="button" class="close" (click)="getMaster(id,'')" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body  col-sm-12 form-group">
                    <iframe width="100%" Height="400 px" [src]="modalURL|safe"></iframe>
                </div>
            </div>
        </div>
    </div>
    <div class=" col-sm-12">
        <div class="titlebar d-flex align-items-center justify-content-center m-2">
            <div class="titlebar-text">
                <i class="fa fa-briefcase text-primary"></i>
                <span class="ml-2 page-title">Manage General Masters</span>
            </div>
        </div>
        <div class="col-sm-2 " style="height: 80vh; overflow-y: scroll;">
            <div *ngFor="let master of masters" class="mb-2 button"
                [ngClass]="ManageMasterName == master.GenDescr ? 'active' : ''">
                <a (click)="getMaster(master.GenID,master.GenDescr)">
                    <span>{{master.GenDescr}}</span>
                </a>
            </div>
        </div>
        <div class="col-sm-10">
            <div class="col-sm-12" [hidden]="HideMasterDetails">

                <div class="col-sm-12"
                    style="background-color: #eee; border:1px solid #ddd;padding-top:10px; padding-bottom: 10px;">

                    <div class="col-sm-6">
                        <form #SearchGenMaster="ngForm" [formGroup]="FormSearchGenMaster"
                            (ngSubmit)="onSearchGenMaster(SearchGenMaster.value);">
                            <div class="col-sm-6"><input class="form-control" formControlName="txtSearch"
                                    placeholder="Search here" autofocus="autofocus" name="txtSearch" type="text"
                                    value=""></div>
                            <div class="col-sm-2"><input class="btn btn-primary btn-sm-12" type="submit" value="Go">
                            </div>

                        </form>
                    </div>
                    <div class="col-sm-2">&nbsp;</div>

                    <div class="d-flex" *ngFor="let mDtl of masters; let i=index">
                        <div class="form-group col-sm-6"
                            *ngIf="this.RightsID.includes('202042001') || this.RightsID.includes('202042021') ; then ADDMasterLink else ADDMaster">
                        </div>
                        <ng-template #ADDMasterLink>
                            <button type="button" title="Create {{mDtl.GenDescr}} Master" *ngIf="mDtl.GenID==this.id"
                                class="btn btn-primary ml-auto " data-toggle="modal"
                                (click)="OpenModal('/add-masters',mDtl.GenDescr,'0');" data-target="#ModalPopUP">
                                <i class="fa fa-plus font-16"></i>
                            </button>
                        </ng-template>
                        <ng-template #ADDMaster>
                            <a href="module/0">Create {{mDtl.GenDescr}} Master</a>
                        </ng-template>

                    </div>

                </div>
                <div class="col-sm-9">&nbsp;</div>
                <br><br><br>
                <div class="col-sm-12">
                    <table style="border-collapse: collapse;" class="table table-bordered" border="gray solid 1px;">
                        <thead>
                            <tr *ngFor="let mDtl of masters; let i=index ">
                                <th colspan="4" class="content-header-td" *ngIf="mDtl.GenID==this.id">Manage
                                    {{mDtl.GenDescr}} Master</th>

                            </tr>
                            <tr>
                                <th style="width:70px;">Sr. No.</th>
                                <th style="width:300px;">Name</th>
                                <th style="width:250px;">Short Name</th>
                                <th style="width:250px;">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="this.MsgType != 0">
                                <tr
                                    *ngFor="let mDtl of master | paginate: { itemsPerPage: 8, currentPage: pageNumber }; let i=index ">

                                    <td>{{(pageNumber - 1) * 8 + i +1 }}</td>
                                    <td>
                                        <div class="form-group col-sm-6"
                                            *ngIf="this.RightsID.includes('202042001') || this.RightsID.includes('202042021') ; then EditMasterLink else EditMaster">
                                        </div>
                                        <ng-template #EditMasterLink>
                                            <a target="_blank" data-toggle="modal"
                                                (click)="OpenModal1('/add-masters',mDtl.GenDescr,mDtl.ID);"
                                                data-target="#ModalPopUP">{{mDtl.MainDescr}}</a>
                                        </ng-template>
                                        <ng-template #EditMaster>
                                            <a href="module/0">{{mDtl.MainDescr}}</a>
                                        </ng-template>

                                    </td>
                                    <td>{{mDtl.Abbrv}}</td>
                                    <td>
                                        <div class="form-group col-sm-6"
                                            *ngIf="this.RightsID.includes('202042001') || this.RightsID.includes('202042021') ; then DisableMasterLink else DisableMaster">
                                        </div>
                                        <ng-template #DisableMasterLink>
                                            <input type="submit" class="btn"
                                                [ngClass]="mDtl.Status == 'Enable' ? 'btn-success' : 'btn-warning'"
                                                (click)="disablefunction(mDtl.ID);" value={{mDtl.Status}}> &nbsp; &nbsp;
                                            &nbsp;
                                        </ng-template>
                                        <ng-template #DisableMaster>
                                            &nbsp;
                                        </ng-template>

                                        <div class="form-group col-sm-6"
                                            *ngIf="this.RightsID.includes('202042021') ; then DeleteMasterLink else DeleteMaster">
                                        </div>
                                        <ng-template #DeleteMasterLink>
                                            <i class="fa fa-trash font-16 text-danger cursor-pointer"
                                                (click)="deleteGenMaster(mDtl.ID)" title="Delete"></i>
                                        </ng-template>
                                        <ng-template #DeleteMaster>
                                            <i class="fa fa-trash font-16 text-danger cursor-pointer"
                                                (click)="onDelete()" title="Delete"></i>
                                        </ng-template>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                    <ng-container *ngIf="this.MsgType != 0">
                        <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
                    </ng-container>
                </div>
            </div>
        </div>

    </div>

    <div class="form-group mt-2" style="display:none;">
        <div class="form-check">
            <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true
                [(ngModel)]="options.autoClose">
            <label for="autoClose">Auto close alert after three seconds</label>
        </div>

    </div>

</my-content>
<my-content placeholder="main">

</my-content> -->
}